// extracted by mini-css-extract-plugin
export default {"containerWrapper":"Kontakt_containerWrapper__DYl0L","cardCustom":"Kontakt_cardCustom__oQKvE","sectionButtons":"Kontakt_sectionButtons__LRY97"};